import React, { useState } from "react";
import Yacc from "../yacc.js";
import translateService from "../common/translateService";
import cookieService from "../services/cookieService";

import "./CookieConsentEditor.scss";
import gtagAndFqbInitService from "../services/marketingAndAnalytics/gtagAndFqbInitService.js";
import consentModePrivacyService from "../services/marketingAndAnalytics/consentModePrivacyService.js";
function CookieConsentEditor() {
  var prefix = "cookieConsent";

  var yaccInstance = new Yacc({
    cookiePageUrl: cookiePageUrl,
  });
  yaccInstance.handleBanner();

  const cookieValues = cookieService.getDecodedCookieConsentValues();

  const [data, setData] = useState({
    showBanner:
      cookieValues === null
        ? true
        : cookieValues.ShowBanner === null ||
          cookieValues.ShowBanner === undefined
        ? true
        : cookieValues.ShowBanner,
    firstParty: true,
    thirdParty: cookieService.getThirdParty(),
    marketingParty: cookieService.getMarketingParty(),
  });

  function handleClick(e, cookieType) {
    e.preventDefault();
    if (cookieType === "thirdPartyAccepted") {
      var accept = data.thirdParty;
      let newCookies = {
        ...data,
        thirdParty: !accept,
        marketingParty: accept === true ? false : data.marketingParty, // se sto togliendo autorizzazione 3rdParty, tolgo anche marketingParty
      };
      cookieService.setCookieConsent(newCookies);
      setData(newCookies);
    }
    if (cookieType === "marketingPartyAccepted") {
      var accept = !data.marketingParty;
      let newCookies = {
        ...data,
        thirdParty: accept === true ? true : data.thirdParty, // se sto mettendo marketing, metto anche 3rdParty
        marketingParty: accept,
      };
      gtagAndFqbInitService.initLibs().then(({ gtag }) => {
        consentModePrivacyService.setConsent({ gtag, accept });
      });
      cookieService.setCookieConsent(newCookies);
      setData(newCookies);
    }
  }

  const consent = translateService.get(`common.consent`);

  const firstParty = translateService.get(`${prefix}.firstParty`);

  const firstPartyAccepted = translateService.get(
    `${prefix}.firstPartyAccepted`
  );
  const firstPartyAcceptedExplanation = translateService.get(
    `${prefix}.firstPartyAcceptedExplanation`
  );

  const marketingParty = translateService.get(`${prefix}.marketingParty`);
  const marketingPartyAccepted = translateService.get(
    `${prefix}.marketingPartyAccepted`
  );
  const marketingPartyAcceptedExplanation = translateService.get(
    `${prefix}.marketingPartyAcceptedExplanation`
  );

  const thirdParty = translateService.get(`${prefix}.thirdParty`);
  const thirdPartyAccepted = translateService.get(
    `${prefix}.thirdPartyAccepted`
  );
  const thirdPartyAcceptedExplanation = translateService.get(
    `${prefix}.thirdPartyAcceptedExplanation`
  );

  return (
    <div>
      <div className="cookie-consent-editor">
        <div dangerouslySetInnerHTML={{ __html: firstPartyAccepted }} />
        <div style={{ display: "flex", marginBottom: "0" }}>
          <strong style={{ paddingTop: "9px", paddingBottom: "6px" }}>
            {firstParty}
          </strong>
          <ul className="sub-navigation__list ">
            <li className="sub-navigation__list-item">
              <a
                className={
                  data.firstParty
                    ? "sub-navigation__check  sub-navigation__check--active"
                    : "sub-navigation__check"
                }
                href="#"
                onClick={(e) => handleClick(e, "firstPartyAccepted")}>
                {consent} <sup className="sub-navigation__qty qty"></sup>
              </a>
            </li>
          </ul>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: firstPartyAcceptedExplanation,
          }}
        />
      </div>
      <div>
        <div dangerouslySetInnerHTML={{ __html: marketingPartyAccepted }} />
        <div style={{ display: "flex", marginBottom: "0" }}>
          <strong style={{ paddingTop: "9px", paddingBottom: "6px" }}>
            {marketingParty}
          </strong>
          <ul className="sub-navigation__list ">
            <li className="sub-navigation__list-item">
              <a
                className={
                  data.marketingParty
                    ? "sub-navigation__check  sub-navigation__check--active"
                    : "sub-navigation__check"
                }
                href="#"
                onClick={(e) => handleClick(e, "marketingPartyAccepted")}>
                {consent} <sup className="sub-navigation__qty qty"></sup>
              </a>
            </li>
          </ul>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: marketingPartyAcceptedExplanation,
          }}
        />
      </div>
      <div>
        <div dangerouslySetInnerHTML={{ __html: thirdPartyAccepted }} />
        <div style={{ display: "flex", marginBottom: "0" }}>
          <strong style={{ paddingTop: "9px", paddingBottom: "6px" }}>
            {thirdParty}
          </strong>
          <ul className="sub-navigation__list ">
            <li className="sub-navigation__list-item">
              <a
                className={
                  data.thirdParty
                    ? "sub-navigation__check  sub-navigation__check--active"
                    : "sub-navigation__check"
                }
                href="#"
                onClick={(e) => handleClick(e, "thirdPartyAccepted")}>
                {consent} <sup className="sub-navigation__qty qty"></sup>
              </a>
            </li>
          </ul>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: thirdPartyAcceptedExplanation,
          }}
        />
      </div>
    </div>
  );
}
export default CookieConsentEditor;
